import req from "@/methods/request"

//登录
export const getLogin = function (data) {
    return req({
        url: '/manage/login',
        ...data
    })
}

//读取当前登录用户信息
export const getCurrentUser = function (data) {
    return req({
        url: '/manage/getCurrentUser',
        ...data
    })
}

//读取当前登录用户的菜单
export const getCurrentMenu = function (data) {
    return req({
        url: '/manage/getCurrentMenu',
        ...data
    })
}

//编辑当前用户密码
export const modifyPassword = function (data) {
    return req({
        url: '/manage/modifyPassword',
        ...data
    })
}

//获取菜单列表
export const getMenuList = function (data) {
    return req({
        url: '/manage/systemMenuList',
        ...data
    })
}

//获取菜单详情
export const getMenuInfo = function (data) {
    return req({
        url: '/manage/systemMenuInfo',
        ...data
    })
}

//新增菜单
export const addMenu = function (data) {
    return req({
        url: '/manage/addSystemMenu',
        ...data
    })
}

//编辑菜单
export const saveMenu = function (data) {
    return req({
        url: '/manage/saveSystemMenu',
        ...data
    })
}

//编辑菜单状态
export const changeMenu = function (data) {
    return req({
        url: '/manage/changeSystemMenu',
        ...data
    })
}

//编辑菜单排序号
export const getSortNumber = function (data) {
    return req({
        url: '/manage/saveMenuSortNumber',
        ...data
    })
}

//删除菜单
export const delMenu = function (data) {
    return req({
        url: '/manage/delSystemMenu',
        ...data
    })
}

//获取选择菜单列表
export const selectMenuList = function (data) {
    return req({
        url: '/manage/selectMenuList',
        ...data
    })
}

//获取角色列表
export const systemRoleList = function (data) {
    return req({
        url: '/manage/systemRoleList',
        ...data
    })
}

//获取角色详情数据
export const systemRoleInfo = function (data) {
    return req({
        url: '/manage/systemRoleInfo',
        ...data
    })
}

//新增角色
export const addSystemRole = function (data) {
    return req({
        url: '/manage/addSystemRole',
        ...data
    })
}

//编辑角色
export const saveSystemRole = function (data) {
    return req({
        url: '/manage/saveSystemRole',
        ...data
    })
}

//编辑角色状态
export const changeSystemRole = function (data) {
    return req({
        url: '/manage/changeSystemRole',
        ...data
    })
}

//删除角色
export const delSystemRole = function (data) {
    return req({
        url: '/manage/delSystemRole',
        ...data
    })
}

//选择角色
export const selectRoleList = function (data) {
    return req({
        url: '/manage/selectRoleList',
        ...data
    })
}

//用户列表
export const systemUserList = function (data) {
    return req({
        url: '/manage/systemUserList',
        ...data
    })
}

//获取用户信息
export const systemUserInfo = function (data) {
    return req({
        url: '/manage/systemUserInfo',
        ...data
    })
}

//新增用户
export const addSystemUser = function (data) {
    return req({
        url: '/manage/addSystemUser',
        ...data
    })
}

//编辑用户
export const editSystemUser = function (data) {
    return req({
        url: '/manage/saveSystemUser',
        ...data
    })
}

//启用禁用用户
export const changeSystemUser = function (data) {
    return req({
        url: '/manage/changeSystemUser',
        ...data
    })
}

//删除用户
export const delSystemUser = function (data) {
    return req({
        url: '/manage/delSystemUser',
        ...data
    })
}

//重置用户密码
export const resetPassword = function (data) {
    return req({
        url: '/manage/resetPassword',
        ...data
    })
}

//重置用户角色
export const resetUserRole = function (data) {
    return req({
        url: '/manage/resetUserRole',
        ...data
    })
}